// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.Page
import org.mifos.mobile.core.model.entity.client.Client
import org.mifos.mobile.core.model.entity.client.ClientAccounts

@OptIn(InternalKtorfitApi::class)
public class _ClientServiceImpl(
  private val _ktorfit: Ktorfit,
) : ClientService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun clients(): Flow<Page<Client>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<Page<Client>>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getClientForId(clientId: Long): Flow<Client> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<Client>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getClientImage(clientId: Long): Flow<HttpResponse> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}/images")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<HttpResponse>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getClientAccounts(clientId: Long): Flow<ClientAccounts> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}/accounts")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<ClientAccounts>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getAccounts(clientId: Long, accountType: String?): Flow<ClientAccounts> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "clients/${"$clientId".encodeURLPath()}/accounts")
        accountType?.let{ parameter("fields", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<ClientAccounts>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _ClientServiceProvider : ClassProvider<ClientService> {
  override fun create(_ktorfit: Ktorfit): ClientService = _ClientServiceImpl(_ktorfit)
}

public fun Ktorfit.createClientService(): ClientService = _ClientServiceImpl(this)
